export class StringConstants {
  PROD = false;

  FEATURE_STATUS_AVAILABLE = "available" as const;
  FEATURE_STATUS_NOT_IN_PLAN = "not-in-plan" as const;
  FEATURE_STATUS_ADMIN_DISABLED = "admin-disabled" as const;

  inkfree = "inkfree";
  // localStorage key holding a pending AWS Marketplace setup claim ({ claim, savedAt }) across the sign-in or
  // sign-up detour; cleared on link, on an invalid claim, and after AWS_MARKETPLACE_CLAIM_TTL_MS.
  AWS_MARKETPLACE_CLAIM_KEY = "awsMarketplaceSetupClaim";
  AWS_MARKETPLACE_CLAIM_TTL_MS = 24 * 60 * 60 * 1000;
  // ACCOUNT.BILLING_SOURCE of an account billed by AWS Marketplace: My Plan hides every Stripe purchase.
  AWS_MARKETPLACE_BILLING_SOURCE = "AWS_MARKETPLACE";
  // After a link whose plan is still pending (AWS provisions a new contract within minutes), the setup page
  // re-reads the plan this often, this many times, then reloads the features once the paid plan has landed.
  AWS_MARKETPLACE_PLAN_POLL_MS = 10 * 1000;
  AWS_MARKETPLACE_PLAN_POLL_ATTEMPTS = 18;
  inkfreeSupportEmail = "support@inkfree.app";
  //Firebase
  FIREBASE_VAPID_KEY =
    "BOl9M96dD8Ba71zyz6jtxEkpPMYgyuUJV9jxzPcwlstYC3QGBzLTV4DJJkUCXl_n0vFyFSOi9IoIRA2ptWfWc90";
  // Public browser key: ships in the JS bundle; access is limited by its GCP referrer/API restrictions (hence the scanner allow markers).
  firebase_apiKey = "AIzaSyDQFgqVotfqgZqk1OnILgGYyI0KiA0aTBg"; // gitleaks:allow nosemgrep: generic.secrets.security.detected-generic-api-key.detected-generic-api-key
  firebase_authDomain = "healthcaresages.firebaseapp.com";
  firebase_projectId = "healthcaresages";
  firebase_storageBucket = "healthcaresages.appspot.com";
  firebase_messagingSenderId = "248661924179";
  firebase_appId = "1:248661924179:web:92287c0464d7e50c3069a6";
  firebase_measurementId = "G-BK8QKBREDQ";

  //contentTypes
  applicationJSON = { "Content-Type": "application/json" };
  fileJSON = { "Content-Type": "text/csv" };
  multipartForm = {};

  notification = "notification";
  error = "error";
  success = "success";
  warning = "warning";
  info = "info";
  web = "web";
  autoHideDuration = 600 * 1000; //in milliseconds

  RECAPTCHA_SITE_KEY = "6Lc6hiAqAAAAABUxVff-zC2KBqRtoi-tH_Q8_0oY";

  // Regex
  EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/;

  //Email validation Regex
  regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  regexPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,100}$/;
  //Phone Number Regex
  phoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  // Only Characters Regex
  characterRegex = /^[A-Za-z ]*$/;
  passwordValidationRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[#@$!%*?&])(?=.*[0-9])[A-Za-z\d#@$!%*?&]{8,}/;

  // Text formatting
  bold = "bold";
  italic = "italic";
  strikethrough = "strikethrough";
  boldMarkdownSymbol = "*";
  italicMarkdownSymbol = "_";
  strikethroughMarkdownSymbol = "~";

  // Time-Out
  SEARCH_TIME_OUT = 1000;
  LIMIT_PAGE = 5;

  //Payment plan
  FREE_PLAN_ID = "1cdeae1eda040176ab2907d0c1783bff";

  pendingVerificationErrorMessage =
    "Account verification is pending. Please check your email to complete the activation";

  ssoEnforcedErrorMessage =
    "Password sign-in is disabled for your organization. Please sign in with single sign-on (SSO) instead.";
  ssoEnforcedErrorCode = "SSO_ENFORCED";

  //file types
  jpeg = ".jpeg";
  JPEG = ".JPEG";
  JPG = "JPG";
  jpg = ".jpg";
  png = ".png";
  PNG = ".PNG";
  gif = ".gif";
  bmp = ".bmp";
  tiff = ".tiff";
  pdf = ".pdf";
  PDF = ".PDF";
  doc = ".doc";
  docx = ".docx";
  txt = ".txt";
  xls = ".xls";
  xlsx = ".xlsx";
  FileUrlPrefix = `https://view.officeapps.live.com/op/embed.aspx?src=`;

  ALLOWED_ATTACHMENT_TYPE = [
    this.jpeg,
    this.gif,
    this.jpg,
    this.pdf,
    this.png,
    this.jpeg,
    this.jpg,
    this.pdf,
    this.png,
    this.txt,
    this.doc,
    this.docx,
  ];

  //date range intervals
  currentWeek = "Current Week";
  previousWeek = "Previous Week";
  lastSevenDays = "Last 7 Days";
  currentMonth = "Current Month";
  previousMonth = "Previous Month";
  allTime = "All time";
  lastThirtyDays = "Last 30 Days";
  reset = "Reset";

  DATE_RANGE_FILTERS = [
    this.allTime,
    this.currentWeek,
    this.previousWeek,
    this.lastSevenDays,
    this.currentMonth,
    this.lastThirtyDays,
    // this.reset,
  ];

  TAGS_LIMIT = 25;

  //btn-labels
  approve = "Approve";
  reject = "Reject";
  submit = "Submit";
  declined = "Declined";
  delegated = "Delegated";
  deleteBtn = "Delete";
  delegate = "Delegate";
  decline = "Decline";
  voidBtn = "Void";
  Resend = "Resend";
  copy = "Copy";
  download = "Download";
  create = "Create";
  update = "Update";
  use = "Use";
  save = "Save";
  close = "Close";
  add = "Add";
  createRole = "Create Role";
  editRole = "Edit Role";
  rolesTable = "Roles";
  done = "Done";
  back = "Back";
  next = "Next";
  previous = "Previous";
  send = "Send";
  sign = "Sign";
  scheduleRequest = "Schedule Request";
  finish = "Finish";
  downloadDocsAsZip = "Download documents as zip";
  downloadDoc = "Download document";
  makePayment = "Make Payment";
  BACK_TO_HOME = "Go Back";

  // Cloud storage provider keys (must match backend service names)
  ONEDRIVE = "onedrive";
  GOOGLE_DRIVE = "googledrive";
  DROPBOX = "dropbox";
  BOX = "box";

  reminders = "Reminders";
  signRequestConfig = "Request Config";
  emailContent = "Email content";

  formatting = "Formatting";
  fieldData = "Field Data";
  validations = "Validations";

  //common-tabs
  active = "Active";
  inactive = "Inactive";
  general = "General";
  documents = "Documents";
  users = "Users";
  roleManagement = "Role Management";

  //component name pages
  DASHBOARD = "Dashboard";
  TEMPLATES = "Templates";
  WEB_FORMS = "Web Forms";
  CONTACTS = "Contacts";
  CONFIGURATIONS = "Configurations";
  SENT = "Sent";
  SIGNREQUEST = "Sign Request";
  INBOX = "Inbox";
  REPORTS = "Reports";
  INSIGHTS = "Insights";
  UPGRADE_PLAN = "Upgrade Plan";
  RENEWABLE_DOCS = "Renewable Docs";
  REPORT = "Report";
  ANALYTICS = "Analytics";

  //Templates
  folder = "folder";
  template = "template";

  //Request TYpes
  request = "request";
  inboxRequest = "inbox";
  sentRequest = "sent";
  sharedRequest = "shared";
  configurations = "configurations";

  //Folder Item operations
  rename = "Rename";
  deleteFolder = "Delete";
  moveFolder = "Move";
  newSubfolder = "New Subfolder";
  createNewFolder = "Create New Folder";
  deleteAnyway = "Delete anyway";
  updateTemplate = "Update Template";
  cancel = "Cancel";
  view = "View";
  delete = "Delete";

  //Sign request row action menu labels
  viewRequest = "View request";
  editDraft = "Edit draft";
  sendReminder = "Send reminder";
  moveToFolder = "Move to folder";
  duplicate = "Duplicate";
  voidRequest = "Void request";

  //fields types
  signature = "signature";
  text = "text";
  email = "email";
  name = "name";
  initials = "initials";
  checkbox = "checkbox";
  radioButton = "radio_button";
  date = "date";
  dateSigned = "date signed";
  companyName = "company name";
  title = "title";
  attachment = "attachment";
  dropDown = "drop_down";
  anySigner = "Any signer";

  selfSigned = "Self Sign";
  certifiedSign = "Certified Sign";

  //for Certificate
  notariusverified = "Certified Sign";
  selfsigned = " Self Sign";
  used = "Used";
  left = "Left";
  freeTrial = "Free Trial";

  //AppPlanLimit Entity
  selfSignedEnveloped = "SelfSignedEnvelope";
  notariusVerifiedEnvelope = "NotariusVerifiedEnvelope";

  cc = "cc";

  // status
  pending = "Pending";
  signed = "Signed";
  delay = "Delay";
  scheduled = "Scheduled";
  voided = "Voided";
  expired = "Expired";
  completed = "Completed";
  approved = "Approved";
  rejected = "Rejected";
  skipped = "Skipped";
  inReview = "InReview";
  inReviewLabel = "In Review";
  draft = "Draft";
  Delegated = "Delegated";
  waitingForOthers = "Waiting for others";
  alreadySigned = "Already signed, waiting for others";
  yourTurnToSign = "Now it's your turn to sign";
  /**
   * Display labels for the inbox row status chip. Kept apart from the status
   * values above because they are written from the reader's point of view — the
   * same "Pending" request reads differently depending on whose turn it is.
   */
  inboxStatusLabels = {
    yourTurn: "Your turn to sign",
    waitingForOthers: "Waiting for others",
    signed: "Signed",
    declined: "Declined",
    delegatedByYou: "Delegated by you",
  };
  /**
   * Trailing clauses on an inbox row's meta line ("Priya Shah · May 8, 11:42 AM
   * · you've signed · awaiting 2 others"). Assembled by `getInboxRowState`.
   */
  inboxRowNotes = {
    youSigned: "you've signed",
    awaiting: "awaiting",
    otherSingular: "other",
    otherPlural: "others",
    declined: "you declined",
    voided: "voided by sender",
  };
  /** Trailing button on an inbox row — one per actionable state. */
  inboxRowActions = {
    sign: "Sign",
    download: "Download",
  };
  /**
   * Same buttons below `md`, for labels the reference shortens to fit the
   * narrower action slot.
   */
  inboxRowActionsCompact = {
    sign: "Sign",
    download: "Download",
  };
  /** Signer-perspective filter pills above the inbox list. */
  inboxTabLabels = {
    all: "All requests",
    action: "Action needed",
    waiting: "In progress",
    completed: "Completed",
    declined: "Declined",
    closed: "Closed",
  };
  verificationLocked = "VerificationLocked";
  verificationLockoutMessage =
    "Too many failed attempts. Please contact the requester.";
  verificationMaxAttempts = 5;

  /**
   * Signer identity verification (IDV) copy. Signer-facing text says
   * "identity", never "IDV" / "KBA" (CLAUDE-DESIGN.md copy rules). `{name}`-style
   * tokens are filled with `fillCopy` (helpers/methods).
   */
  /** Message prefix on the `403` every signer document call answers until IDV passes. */
  IDV_REQUIRED_PREFIX = "IDV_REQUIRED:";
  /** Message prefix on the `409` from starting an IDV session with no attempts left. */
  IDV_BLOCKED_PREFIX = "IDV_BLOCKED:";
  /** `409` prefix from starting a session when the signer has already passed. */
  IDV_ALREADY_VERIFIED_PREFIX = "IDV_ALREADY_VERIFIED:";
  /** `409` prefix from a start that raced another (double click): retry once. */
  IDV_STARTING_PREFIX = "IDV_STARTING:";
  /** `globalEmitter` event: a signer call was refused with `IDV_REQUIRED:`. */
  IDV_REQUIRED_EVENT = "identityVerificationRequired";

  identityVerification = {
    // ---- sender: the signer's security dropdown (compose / template / bulk)
    securityOptions: {
      idvId: {
        label: "ID + selfie",
        caption: "Photo ID matched to a live selfie",
      },
      idvKba: {
        label: "Knowledge questions",
        caption: "Questions only the signer should be able to answer",
      },
      idvBoth: {
        label: "ID + selfie and questions",
        caption: "Both checks, photo ID first",
      },
    },
    inPersonTooltip: "Not available for in-person signing.",
    methods: {
      ID_DOCUMENT: {
        label: "Photo ID and selfie",
        desc: "A government ID matched to a live selfie",
      },
      KBA: {
        label: "Knowledge questions",
        desc: "A few questions only the signer should be able to answer",
      },
    },
    // ---- sender: request detail
    senderBadges: {
      NOT_STARTED: "Not verified",
      IN_PROGRESS: "Verifying",
      FAILED: "Failed, can retry",
      BLOCKED: "Blocked",
      PASSED: "Verified",
    },
    methodStatuses: {
      NOT_REQUIRED: "Not required",
      NOT_STARTED: "Not started",
      IN_PROGRESS: "In progress",
      FAILED: "Failed",
      BLOCKED: "Blocked",
      PASSED: "Passed",
    },
    attemptsUsed: "{used} of {max} attempts",
    blockedNote:
      "{name} couldn't verify their identity after {max} attempts and can't sign. Replace them with Update, or Void the request, from the request's menu.",
    badgeAriaLabel: "Identity verification: {status}",
    // ---- signer
    signerMethods: {
      ID_DOCUMENT: "Photo ID and selfie",
      KBA: "A few questions",
    },
    introTitle: "Verify your identity",
    introBody:
      "{sender} needs to confirm it's you before you can view this document. It takes about 2 minutes.",
    introBodyNoSender:
      "The sender needs to confirm it's you before you can view this document. It takes about 2 minutes.",
    needIdDocument: "A government-issued photo ID and a device with a camera.",
    needKba: "A few minutes to answer some questions about yourself.",
    needTitle: "What you'll need",
    start: "Start",
    whyLink: "Why am I being asked this?",
    whyBody:
      "The sender asked us to confirm the identity of everyone who signs this document. Your ID images are handled by our verification partner. Inkfree only keeps the result.",
    stepLabel: "Step {step} of {total}: {method}",
    testModeTitle: "Test mode",
    testModeBody: "No real check runs here. Choose the result to simulate.",
    simulatePass: "Simulate pass",
    simulateFail: "Simulate fail",
    partnerTitle: "Verification partner",
    embedPlaceholder:
      "The verification step isn't available in this browser yet. Please try again later.",
    redirecting: "Taking you to our verification partner…",
    checkingTitle: "Checking your details…",
    checkingBody: "This usually takes a few seconds.",
    stillChecking:
      "Still checking… you can keep this page open, or we'll email you when it's done.",
    methodPassedTitle: "Step complete",
    methodPassedBody: "Next: {method}.",
    continueLabel: "Continue",
    passedTitle: "You're verified",
    passedBody: "Thanks for confirming it's you.",
    continueToDocument: "Continue",
    failedTitle: "We couldn't verify you",
    tryAgain: "Try again",
    attemptsLeftOne: "1 attempt left",
    attemptsLeftMany: "{count} attempts left",
    blockedTitle: "Verification locked",
    blockedBody:
      "You've used all your attempts. We've let {sender} know. They'll contact you about next steps.",
    blockedBodyNoSender:
      "You've used all your attempts. We've let the sender know. They'll contact you about next steps.",
    timedOutTitle: "This verification timed out",
    timedOutBody: "This didn't use up an attempt.",
    startAgain: "Start again",
    startError: "We couldn't start the verification. Please try again.",
    /**
     * Vendor `failureReason` codes mapped to a plain hint; unknown codes fall
     * back to `default`. Only codes the backend documents today are listed —
     * extend once the real vendor's code list is known.
     */
    failureHints: {
      DOCUMENT_UNREADABLE:
        "Make sure your whole ID is in the frame, flat and well lit.",
      PROVIDER_ERROR:
        "Something went wrong on our partner's side. Please try again.",
      TEST_SIMULATED_FAILURE: "This was a simulated failure (test mode).",
      default: "Check your details and try again.",
    } as Record<string, string>,
  };

  auditStatuses = {
    requested: "requested",
    edited: "edited",
    sent: "sent",
    approved: "approved",
    rejected: "rejected",
    scheduled: "scheduled",
    opened: "opened",
    signed: "signed",
    completed: "completed",
    voided: "voided",
    declined: "declined",
    resent: "resent",
    sentForApproval: "sent for approval",
    delegated: "delegated",
    sentOtp: "sent otp",
    codeVerified: "verified code/otp",
    inPersonStarted: "in-person started",
    inPersonHandoff: "in-person handoff",
    signedInPerson: "signed in person",
    inPersonReturned: "in-person returned",
    inPersonAbandoned: "in-person abandoned",
    inPersonHostLinkSent: "in-person host link sent",
    inPersonConsentAccepted: "in-person consent accepted",
    attachmentUploaded: "attachment uploaded",
    attachmentRemoved: "attachment removed",
    fieldDataSubmitted: "field data submitted",
  };

  // In-person signing — delivery mode per signer + host-session copy.
  deliveryModes = {
    email: "EMAIL",
    inPerson: "IN_PERSON",
    // Embedded Components: the signer signs inside the partner's app (the
    // embedded wizard only).
    embedded: "EMBEDDED",
  };

  /**
   * Reserved domain the backend assigns to an in-person signer who gave no
   * email. The address is undeliverable and must never reach a screen — match
   * on this suffix, never on the whole string, as the local part varies per
   * signer. See `isPlaceholderSignerEmail` in `InPersonSigningHelper`.
   */
  NO_EMAIL_DOMAIN = "@no-email.invalid";

  inPerson = {
    launchLabel: "Sign in person",
    deliveryEmailLabel: "Send a signing link",
    deliveryEmailCaption: "Delivered to the signer by email or SMS",
    deliveryInPersonLabel: "Sign in person",
    // "the host", never "you": whoever creates the request may not be the one
    // sitting with the signer.
    deliveryInPersonCaption: "Signer signs on the host's device, no email sent",
    sessionBadge: "In-person signing",
    // The hand-off card is what the signer reads once the device is in their
    // hands — the host has already confirmed the hand-off in the dialog before
    // this — so it speaks to the signer, not about them.
    handoffTitle: "Ready to sign?",
    handoffSubtitle:
      "Review the document and complete the fields marked for you. Hand the device back when you're done.",
    handoffContinue: "Agree & start signing",
    returnToHost: "Return to host",
    // Shown when the signer/host tries to leave an active hand-off turn via
    // the browser back button, or a tab close/refresh/navigate-away — the
    // confirm reached by accident, alongside the explicit `returnToHost` button.
    leaveSessionTitle: "End this signing session?",
    leaveSessionMessage:
      "Leaving now ends this signer's turn and returns the device to the host. They'll need to start over from the beginning.",
    leaveSessionConfirm: "End session",
    leaveSessionCancel: "Stay on this page",
    signerLabel: "You're signing as",
    // The completion/return-device chip needs past tense — reusing
    // `signerLabel` there reads as if signing is still in progress.
    signedLabel: "You signed as",
    completeTitle: "You've signed. Return the device to the host.",
    completeSubtitle: "Hand the device back to the host to continue.",
    // Offered on the completion screen to every in-person signer, whether or
    // not they gave an email at hand-off — the last moment the envelope can
    // still reach them directly, so it's always asked, always optional.
    copyPrompt:
      "If you'd like a copy of the signed document by email, enter it below. This is optional.",
    copyEmailLabel: "Your email",
    copyEmailPlaceholder: "name@example.com",
    copyEmailError: "Please enter a valid email",
    continueNext: "Continue",
    // The "return device" card shown right after the completion screen.
    // `returnDeviceTitle` is signer-facing ("you've signed") and covers the
    // "no more in-person signers" branch; the "next signer" branch gets its
    // own title instead, since its subtitle/button address the host, not the
    // signer who just finished — reusing the signer-facing title there read
    // as a mismatch.
    returnDeviceTitle: "You've signed. Return the device to the host.",
    returnDeviceNextSignerTitle: "Ready for the next signer",
    returnDeviceNextSignerSubtitle:
      "There's another in-person signer on this document. Hand the device back to the host — tapping below starts the same hand-off process again, this time for the next signer.",
    startNextSigner: "Start for next signer",
    returnDeviceNoMoreTitle: "No more in-person signers",
    returnDeviceNoMoreSubtitle:
      "Every in-person signer has finished. Any remaining signers will continue by email — you can end the session now.",
    endSession: "End session",
    requestCompletedTitle: "Request completed",
    requestCompletedSubtitle:
      "Every signer has completed this document. It's ready to view.",
    returnToRequest: "Return to request",
    /** Stands in for the name of a walk-in signer, captured only at session time. */
    unnamedSignerLabel: "In-person signer",
    unnamedSignerHint: "Signs on your device — details captured at handover",
    // Fallback only. The server sends a `waitingReason` written for the exact
    // situation (which signer, which order, when the next hand-off opens) —
    // prefer it, and use this when it is absent.
    noSignerReady: "No in-person signer is ready to sign right now.",
    // Title for the not-ready card. Deliberately neutral, because the body
    // beneath it is the server's `waitingReason`, which supplies the specifics.
    waitingOnCurrentLevelTitle: "Not ready to hand off yet",
    /** Precedes the list of recipients the envelope is waiting on. */
    waitingOnLabel: "Waiting on",
    // Shown when the server reports more than one in-person signer the host
    // may hand the device to at the same time (a parallel signing level).
    pickSignerLabel: "Who is signing now?",
    /** A slot whose name the host still types at hand-off. */
    pickSignerPlaceholder: "Details captured at hand-off",
    sessionInProgress:
      "A session is already in progress for this envelope.",
    returnFailed:
      "We couldn't close the in-person session on the server. If the next launch reports a session already in progress, try again in a few minutes.",
    // A 403 reaching the client has already passed the plan and permission
    // gates on the button, so it can't be assumed to be a plan problem.
    launchForbidden: "In-person signing isn't available for this envelope.",
    lockedByAdmin: "In-person signing is currently unavailable.",
    captureTitle: "Who's signing in person?",
    captureSubtitle:
      "Enter the present signer's name. Email is optional — add one to send them their completed copy and to record them on the audit trail.",
    captureConfirm: "Start session",
    // Shown under the confirm button on both the plain consent and the
    // capture card — the moment right after this click is a physical
    // hand-off, not just a form submit, so it's called out explicitly.
    handoffPrepNote: "Once the session starts, hand the device to the signer.",
    /**
     * Three consents, three people, three moments — keep the voices distinct:
     *
     * 1. `authoringConsent*` — the **requester**, setting a signer to sign in
     *    person. Nobody is present yet, and they may not be the host, so it
     *    confirms the arrangement and names the host's duty as the host's.
     * 2. `hostConsent*` — the **host**, device in hand, attesting the signer is
     *    in front of them. This is the one the API requires before `start`.
     * 3. `signerConsent*` — the **signer**, holding the device, agreeing to
     *    sign electronically before the document opens.
     */
    authoringConsentTitle: "Set this signer to sign in person",
    authoringConsentSubtitle:
      "They won't be emailed a signing link. Whoever hosts this signing opens the request and hands them the device once they're together.",
    authoringConsentLabel:
      "I confirm this signer has agreed to sign this document electronically, and that the host will check they're present before handing over the device.",
    authoringConsentError:
      "Please confirm before setting this signer to sign in person.",
    authoringConsentConfirm: "Set to in person",
    // An emailed one-time code has nowhere to go without an address, so the
    // otherwise-optional email is mandatory for these signers.
    emailRequiredOtp: "Email is required",
    emailRequiredOtpReason:
      "This signer verifies with a one-time code sent by email, so a working address is needed.",
    // 2 — the host, about to pass the device over.
    hostConsentTitle: "Confirm the signer is with you",
    hostConsentSubtitle:
      "You're about to hand this device to the signer. They'll review the document and sign on it, then hand it back to you.",
    hostConsentLabel:
      "I confirm this signer is physically present with me and is ready to sign on this device.",
    hostConsentError: "Please confirm the signer is here with you.",
    hostConsentConfirm: "Start session",
    // 3 — the signer, now holding the device. Addressed to them, not the host.
    signerConsentLabel:
      "I agree to sign this document electronically, and to the use of electronic records and signatures.",
    signerConsentHint: "Tick the box above to open your document.",

    // The in-person launch page — reached either from the emailed host link
    // or from "Sign in person" on the view-request page, same flow either
    // way. This first card is a pure hand-off, no API call: the real start
    // happens on confirm of the next (capture) card.
    hostLinkTitle: "In-person signing",
    hostLinkReadyTitle: "Ready to start",
    hostLinkReadySubtitle: (requesterName: string, subject: string) =>
      `${requesterName || "The sender"} sent "${subject}" for in-person signing.`,
    hostLinkStart: "Continue",
    hostLinkLoadFailed:
      "We couldn't load this link. Please try again, or ask the sender for a new one.",
    // The host reopening the link after the request already reached a
    // terminal state — same idea as the requester's own status banner
    // (`ViewRequestStatusMeta.getBannerConfig`), worded for this page's host.
    hostLinkRequestVoidedTitle: "Request voided",
    hostLinkRequestVoidedSubtitle:
      "This request was voided by the requester and can no longer be completed.",
    hostLinkRequestExpiredTitle: "Request expired",
    hostLinkRequestExpiredSubtitle:
      "The signing window closed before this request was completed.",
    hostLinkRequestDeclinedTitle: "Request declined",
    hostLinkRequestDeclinedSubtitle:
      "A signer declined to sign this request. It can no longer be completed.",
  };

  /**
   * Public `/link-expired` landing — where a dead SMS short link lands.
   *
   * Whoever reads this is a signer, not a customer: they have no account, no
   * session, and the link that brought them here carries no envelope, so the
   * page cannot name the sender or offer to reissue anything. The only real
   * way forward is the person who sent the document, which is what this copy
   * says — and it says plainly that support cannot substitute for them, so
   * nobody waits on a reply that was never going to unblock them.
   */
  linkExpired = {
    /** `r=expired` — the link was valid, its 7-day window has closed. */
    contactExpired:
      "Ask whoever sent you this document for a new signing link. They can send one from their Inkfree account, and it will work straight away.",
    /** Anything else — mistyped, long since purged, or deleted by the sender. */
    contactNotFound:
      "Open the full link from the original message once more, in case it was cut short on the way. If it still doesn't open, ask whoever sent you the document to send it again.",
    /**
     * Shown on both cards. Signers who can't reach the sender otherwise write
     * to Inkfree, which cannot help: a replacement link is the sender's to
     * issue. Saying so here is kinder than a support reply days later.
     */
    contactNote:
      "Only the sender can issue a new link — Inkfree can't create one on their behalf.",
  };

  // SMS Delivery — the signing link can be delivered by email, text (SMS) or
  // WhatsApp. Channel values match the API; captions/labels follow the design.
  deliveryChannels = {
    email: "EMAIL",
    sms: "SMS",
    whatsApp: "WHATSAPP",
  };

  /** Country dial codes offered on the delivery / auth phone pickers. */
  countryDialCodes = [
    { code: "+1", name: "United States" },
    { code: "+44", name: "United Kingdom" },
    { code: "+91", name: "India" },
    { code: "+61", name: "Australia" },
    { code: "+49", name: "Germany" },
    { code: "+971", name: "UAE" },
    { code: "+65", name: "Singapore" },
  ];

  /** Search box at the top of `CustomContactNumberInput`'s country menu. */
  countrySearchPlaceholder = "Search country or code";
  countrySearchNoResults = "No matching countries";

  /**
   * The only countries a signer's phone number may be in on the Approvers &
   * Signers step — SMS delivery and phone authentication are US/Canada-only
   * for now, so the country picker there offers just these two rather than
   * letting a requester enter a number nothing can text.
   *
   * ISO-3166 alpha-2, lowercase, as `CustomContactNumberInput` expects.
   * Scoped to that step on purpose: every other phone field in the app
   * (contacts, profile, team invites, registration) stays unrestricted.
   */
  SMS_SUPPORTED_COUNTRIES = ["us", "ca"];

  /** Subject a request starts with, before the sender edits it. */
  SIGN_WITH_INKFREE = "Sign with Inkfree";

  smsDelivery = {
    deliverViaLabel: "Deliver via",
    emailLabel: "Email",
    emailDesc: "Signing link sent by email",
    smsLabel: "Text (SMS)",
    // Sits beside the SMS channel label as a muted suffix, so the requester
    // learns the limit before picking the channel rather than after typing a
    // number the country picker won't accept. Kept out of `smsLabel` itself
    // so the channel keeps its short name wherever it is read back.
    smsRegionNote: "(US and Canada only)",
    smsDesc: "Link texted to their phone",
    whatsAppLabel: "WhatsApp",
    whatsAppDesc: "Link sent on WhatsApp",
    // delivery phone box
    phoneNumberLabel: "Phone number",
    phonePlaceholder: "(555) 000-0000",
    whatsAppNumberPlaceholder: "WhatsApp number",
    extLabel: "Ext",
    extPlaceholder: "1234",
    saveLabel: "Save",
    editLabel: "Edit",
    deliveredToLabel: "Request will be delivered to",
    phoneRequired: "Please enter a phone number for SMS delivery.",
    phoneInvalid: "Please enter a valid phone number (with country code).",
    // phone (SMS OTP) authentication
    securityPhoneLabel: "SMS OTP",
    securityPhoneCaption: "One-time code sent to the signer's phone",
    authTitle: "Phone authentication",
    authNote: "one-time code will be texted to",
    authPlaceholder: "(555) 000-0000",
    sameAsDelivery: "Same as delivery number",
    smsCodeSentToLabel: "SMS code will be sent to",
    authPhoneRequired: "Please enter a phone number for phone authentication.",
    // Consent confirmation shown on Next when any signer is set to receive SMS.
    consentTitle: "Text message consent",
    consentSubtitle: "One quick confirmation before we can text this request.",
    consentCheckbox:
      "I confirm all recipients set to receive text messages have agreed to be texted by Inkfree about this document, as required by the Terms of Service.",
    consentFrequencyLabel: "Message Frequency:",
    consentFrequency: "Typically 1-4 messages per document.",
    consentRatesLabel: "Standard Rates:",
    consentRates: "Message and data rates may apply.",
    consentHelpLabel: "Help & Stop:",
    consentHelp: "Reply HELP for help or STOP to cancel at any time.",
    consentTermsLabel: "Terms of Service",
    consentPrivacyLabel: "Privacy Policy",
    consentContinue: "Continue",
  };

  /**
   * SMS credits — the prepaid wallet that pays for every text the app sends.
   *
   * Never call it a subscription: it is a one-time purchase with no renewal
   * and nothing to cancel, and the word generates support tickets asking how
   * to cancel it.
   */
  /**
   * Manage seats — the in-plan money move under the buy-upfront model. Buying
   * seats charges the prorated difference now; releasing them credits the
   * unused part to the account balance. Adding or removing *users* never comes
   * through here, so the copy never says "user" where it means "seat".
   */
  manageSeats = {
    panelHeading: "Choose how many seats",
    statYouHave: "You have",
    statInUse: "In use",
    statPlanLimit: "Plan limit",
    /** Shown in the Plan limit cell when the plan states no cap. */
    noLimitValue: "∞",
    seatsLabel: "Seats",
    /** `{max}` — the plan's own ceiling, not the seats bought. */
    planLimitHint: "Up to {max} on this plan",
    noLimitHint: "No seat limit on this plan",
    /** `{used}` active users, `{seats}` the chosen count. */
    belowInUse:
      "{used} users are active — you'll choose which {seats} keep a seat.",
    atCapLead: "That's every seat this plan allows —",
    atCapAction: "upgrade for more",
    atCapPlain: "That's every seat this plan allows — upgrade for more.",
    unchanged: "This is the number of seats you already have.",

    // Order bar
    /** `{count}` seats added / released, `{unit}` the pluralised word. */
    orderLineAdded: "{count} {unit} added",
    orderLineReleased: "{count} {unit} released",
    orderLineUnchanged: "No change",
    orderNoteUnchanged: "Step the count to see what it costs.",
    /** `{amount}` the new per-cycle bill, `{date}` when it is charged. */
    orderNoteRenewalDated: "Then {amount} on {date}",
    orderNoteRenewal: "Then {amount} at your next renewal",
    /** A release is never charged; the money comes back as account credit. */
    orderNoteReleaseLead: "Unused time is credited to your balance",
    noTotal: "—",
    /** Itemisation shown only when account credit covers part of the charge. */
    seatCostLabel: "Seat cost",
    creditAppliedLabel: "Account credit applied",
    coveredByCredit: "Covered entirely by your account credit.",
    /** `{amount}` — `amountDueNow` bakes tax in, so it has to be named. */
    taxNote: "Includes {amount} tax.",
    previewFailedBuy:
      "We couldn't load the exact cost right now. You'll be charged a prorated amount for the extra seats.",
    previewFailedRelease:
      "We couldn't load the exact credit right now. Releasing seats credits the unused part of this period to your account balance.",

    // Commit button
    buyLabel: "Buy {count} {unit}",
    releaseLabel: "Release {count} {unit}",
    saveLabel: "Save",
    buyingLabel: "Buying…",
    releasingLabel: "Releasing…",
    seatUnitOne: "seat",
    seatUnitMany: "seats",
    /** The header control, which toggles the panel rather than opening it. */
    toggleLabel: "Manage seats",
    closeLabel: "Close",
  };

  /**
   * "Choose your plan". The plan columns come from the public catalog, so a
   * failed read leaves the screen with nothing to sell — say that and offer
   * the read again, rather than holding the columns on their skeleton.
   */
  /**
   * Plan & Billing for an account billed by AWS Marketplace. AWS owns the
   * plan, seats and cancellation; core refuses every Stripe purchase (409),
   * so the screen offers none and points to the AWS subscription instead.
   */
  awsMarketplaceBilling = {
    badge: "AWS Marketplace",
    description:
      "Your plan and seats are billed through AWS Marketplace and follow your AWS subscription.",
    seatsLabel: "Seats",
    seatsValue: "{used} of {limit} in use",
    // AWS lets a contract buyer add seats, move up a tier and turn off auto-renewal, but not cancel mid-term or
    // reduce seats: that is a seller-initiated cancellation request the buyer approves.
    manageNote:
      "To add seats or move to a higher tier, edit your Inkfree agreement in AWS Marketplace. To stop at the end of your term, turn off auto-renewal there. Changes apply here automatically.",
    cancelNotePrefix: "To cancel sooner or reduce seats, email ",
    manageButton: "Open AWS Marketplace subscriptions",
  };

  upgradePlan = {
    loadFailedTitle: "Plans couldn't be loaded",
    loadFailedBody:
      "Something went wrong reading the plan list. Check your connection and try again.",
    retryLabel: "Try again",
    // Availability chip at the top of each plan card.
    chipCurrent: "CURRENT PLAN",
    chipAvailable: "AVAILABLE FOR {seats}",
    chipUnavailable: "NOT AVAILABLE FOR {seats}",
  };

  smsCredits = {
    // ---- Plan & Billing card ----
    sectionTitle: "SMS Credits",
    sectionDesc:
      "Credits are used when a signer is notified or authenticated by text. 1 credit = 1 SMS.",
    /** Status pill beside the title. */
    badgeActive: "ACTIVE",
    badgeLow: "RUNNING LOW",
    buyLabel: "Buy SMS Credits",
    closeLabel: "Close",

    // Stat strip
    balanceLabel: "BALANCE",
    balanceUnit: "credits left",
    /** `{purchased}` — lifetime credits bought, the meter's denominator. */
    balanceNote: "{purchased} credits purchased to date",
    usedLabel: "USED",
    /**
     * All-time, not this month: the API returns `consumedTotal` only, with no
     * per-month figure and no burn rate, so the label says what the number is.
     */
    usedNote: "credits spent since your first purchase",
    lastPurchaseLabel: "LAST PURCHASE",
    /** `{date}` · `{amount}`, from the newest purchase in the activity feed. */
    lastPurchaseNote: "{date} · {amount} one-time",
    noPurchaseYet: "—",
    noPurchaseNote: "No credit purchases yet",

    /**
     * Low-balance strip. Deliberately makes no projection — the backend
     * exposes no burn rate, so "you will run out in N days" would be invented.
     */
    lowStripText:
      "Texts stop sending at zero — email delivery is unaffected.",
    topUpNow: "Top up now",

    // ---- Buy panel ----
    choosePack: "Choose a credit pack",
    packCreditsLabel: "CREDITS",
    /** `{unit}` — this pack's own tier rate; it differs between packs. */
    packUnit: "{unit} per SMS",
    orEnterAmount: "Or enter an amount",
    customPlaceholder: "e.g. 750",
    customAriaLabel: "Number of credits to buy",
    creditsWord: "credits",
    /** `{min}` comes from the offer, never hardcoded — it is a DB value. */
    customHint: "Minimum {min} credits. Credits never expire.",
    orderLinePack: "{quantity} credits",
    orderLineCustom: "{quantity} credits at {unit} each",
    orderLineInvalid: "Enter between {min} and {max} credits to continue",
    /**
     * Volume tiers mean a typed amount just under a pack can cost more than
     * the pack itself — 999 at $0.050 is $49.95, where the 1,000 pack is
     * $40.00. `{credits}` / `{amount}` name the better deal.
     */
    cheaperPack: "Buy {credits} for {amount} instead — more credits, less money.",
    cheaperPackAction: "Switch to {credits}",
    /**
     * A `409` price change. The message is the backend's own and names the new
     * figure; this is the instruction that goes with it. Never retried
     * silently — the customer re-confirms the new total.
     */
    priceChanged: "Check the new total and buy again.",
    orderNote: "One-time charge to your card — nothing recurring.",
    orderNoteCard:
      "One-time charge to your card ending {last4} — nothing recurring.",
    noTotal: "—",
    buyConfirm: "Buy credits",
    buying: "Buying…",
    managePaymentMethods: "Manage payment methods",
    approvalUnavailable:
      "This card needs bank approval, which couldn't be started. Try a different card.",
    approvalIncomplete: "Card approval was not completed.",
    genericError:
      "There was an error on the server side. Please try again later.",

    /** `{quantity}` / `{balance}` filled in after a completed purchase. */
    purchaseDone: "{quantity} SMS credits added. You now have {balance}.",
    /**
     * 3-D Secure approved, but the credits arrive with Stripe's notification
     * to the backend rather than with the response, so the balance can lag.
     */
    purchasePending:
      "Payment approved. Your credits will appear shortly — your receipt is available now.",

    // ---- Activity feed ----
    // Credits bought and credits spent, sends grouped one line per document
    // per kind per day.
    activityColActivity: "ACTIVITY",
    activityColDate: "DATE",
    activityColDetail: "DETAIL",
    activityColCredits: "CREDITS",
    historyEmptyTitle: "No SMS credit activity yet",
    historyEmptyBody:
      "Credits you buy and the texts they pay for both appear here.",
    typePurchase: "Credit pack purchased",
    typeGrant: "Added by support",
    typeRevoke: "Removed by support",
    typeSigningLink: "Signing link by text",
    /** `{name}` is filled in only on a single-recipient line. */
    typeVerification: "SMS OTP — {name}",
    typeVerificationGeneric: "SMS verification code",
    typeSmsSent: "SMS sent",
    /** Unknown type from a newer backend — never drop the row. */
    typeUnknown: "SMS activity",
    /** Trailing detail on a grouped send line. */
    signersDetail: "{count} signers",
    /** Detail on a purchase line: "500 credits · $50.00". */
    purchaseDetail: "{quantity} credits · {amount}",
    loadFailed:
      "We couldn't load your SMS credit balance. Your credits are safe — this is a problem reading them.",
    retry: "Try again",
    loadMore: "Load more",
    loadingMore: "Loading…",

    // ---- Send-for-signature screen ----
    /** `{cost}` / `{balance}` are the credits this send needs and what's left. */
    sendCost: "This send will use {cost} of your {balance} SMS credits.",
    sendCostShort:
      "This send needs {cost} SMS credits and you have {balance}. Buy more to continue.",
    lowBalance: "You have {balance} SMS credits left.",
    /**
     * Appended wherever a cost is quoted, when any signer verifies by text.
     * `{max}` is the cost with every allowed resend spent — the figure the
     * sender can actually be billed, as opposed to the one that gates Send.
     */
    resendHeadroom:
      "Signers can request a new code up to {resends} times, so this request could use up to {max}.",
    emptyBalance:
      "You're out of SMS credits. Signature requests sent by text will be blocked until you top up.",
    buyMore: "Buy more",
    /** Bulk send prices per generated request, so a long run can stop midway. */
    bulkShort:
      "This bulk run needs {cost} SMS credits and you have {balance}. It will stop once the credits run out — requests already sent are unaffected.",
    /** Tooltip on a Send disabled purely for want of credits. */
    sendBlockedTooltip: "Not enough SMS credits to send this request by text.",
  };

  SMS_CREDIT_LOW_BALANCE_THRESHOLD = 20;

  /**
   * Times a signer may ask for a fresh SMS one-time code, on top of the one
   * sent for them. Each is a further message the wallet pays for, so a signer
   * verifying by text can cost up to 1 + this.
   *
   * The rule lives on the server, which returns `remainingResends` on each
   * send-OTP response — but only once a code has already gone out, which is
   * too late to price a send. Mirrored here so the send flow can show the
   * ceiling; if the server's allowance changes, this must change with it.
   */
  SMS_OTP_MAX_RESENDS = 5;

  OAuthProviders = {
    googleAuth: "googleauth",
  };

  GOOGLE_OAUTH_CLIENT_ID =
    "573015443102-vfjcnging3636s4senlr7k2ehsunvmno.apps.googleusercontent.com";

  ALLOWED_RESUME_TYPE = [
    this.jpeg,
    this.gif,
    this.jpg,
    this.pdf,
    this.png,
    this.JPEG,
    this.JPG,
    this.PDF,
    this.PNG,
    this.txt,
  ];

  // Unlayer
  UNLAYER_PROJECT_ID = 33804;

  //For Support Ticket
  USER_DESCRIPTION_LIMIT = 500;

  OFFER_COUPON_CODE = "INKFREE20";
  OFFER_BANNER_LIVE = true;
  OFFER_START_DATE = new Date("2025-11-17");
  OFFER_END_DATE = new Date("2025-12-15");

  // Permissions
  adminPermission = "admin";
  fetchPermission = "fetch";
  addPermission = "add";
  updatePermission = "update";
  downloadPermission = "download";
  sendPermission = "send";
  deletePermission = "delete";
  selfPermission = "self";

  resources = {
    app: "app",
    account: "account",
    candidate: "candidate",
    document: "document",
    sign: "sign",
    template: "template",
    webforms: "webforms",
    billing: "billing",
    contacts: "contact",
    download: "download",
    renewable: "renewable",
    report: "report",
  };

  requestParticipantsType = {
    signers: "signers",
    reviewers: "reviewers",
  };

  requestStatusHeaderMessages = {
    signed: "Request Completed!",
    expired: "Request Expired!",
    voided: "Request Voided!",
    waitingForOthers: "Waiting for Others!",
    nonAssociatedErrorMessage: "No Longer Associated with This Request",
    notYourTurnErrorMessageV1: "Signing Turn Has Changed",
    notYourTurnErrorMessageV2: "Signing Turn Has Changed",
    declined: "Request Declined!",
    rejected: "Request Rejected!",
    requestDelegatedMessage: "Request Delegated!",
    approved: "Request Approved!",
    verificationLocked: "Verification limit reached",
  };

  requestStatusBodyMessages = () => {
    return {
      signed: "All the signers has signed the documents.",
      expired: "This sign request has been expired.",
      voided: "This sign request has been voided by the requester.",
      waitingForOthers:
        "You have signed successfully, waiting for others to sign.",
      declined: "You cannot access this request. It was declined by",
      rejected: "You cannot access this request. It was rejected by",
      verificationLocked:
        "You've entered an incorrect code 5 times. For security, this signing link has been locked. Please contact the requester to resend the request.",
    };
  };

  // Copy for the redesigned guest "Signer status" cards (Signer Status
  // Screens.dc.html). Title + body per terminal status; the body weaves in the
  // requester's name where the design does.
  getSignerStatusCardCopy = (
    requesterName?: string,
    opts?: { declinerName?: string; declinedBySelf?: boolean },
  ) => {
    const sender = requesterName || "the sender";
    // The design's "You rejected…" copy only fits the person who declined.
    // Everyone else on a declined request sees who declined it.
    const declinedCopy = opts?.declinedBySelf
      ? {
          title: "You rejected this document",
          body: `Your rejection has been sent to ${sender} along with your feedback. No signature or approval was applied to the document.`,
        }
      : {
          title: "This request was declined",
          body: `${
            opts?.declinerName || "A signer"
          } declined this signing request, so it can no longer be signed. No action is needed from you — reach out to ${sender} directly if you have any questions.`,
        };
    return {
      [this.expired]: {
        title: "This request has expired",
        body: `This signing request from ${sender} has expired and can no longer be signed. Requests expire after a set time for security. Ask the sender to resend a fresh request to continue.`,
      },
      [this.voided]: {
        title: "This request was voided",
        body: `${sender} has voided this signing request, so it can no longer be opened or signed. No action is needed from you — reach out to the sender directly if you have any questions.`,
      },
      [this.waitingForOthers]: {
        title: "Thanks for signing!",
        body: "Your signature has been recorded. We're now waiting for the other signers to complete their part — you'll be notified by email once everyone is done.",
      },
      [this.approved]: {
        title: "You approved this document",
        body: `Thanks — your approval has been recorded and ${sender} has been notified.`,
      },
      [this.rejected]: declinedCopy,
      [this.declined]: declinedCopy,
      [this.nonAssociatedErrorMessage]: {
        title: "You're no longer part of this request",
        body: `You are no longer part of this signing request. ${sender} may have removed you or reassigned your role. Contact the sender if you believe this is a mistake.`,
      },
      [this.notYourTurnErrorMessageV1]: {
        title: "Your turn to sign has changed",
        body: `Your turn to sign has been changed by ${sender}. There's nothing to do right now — we'll email you a new notification the moment it's your turn to sign.`,
      },
      [this.notYourTurnErrorMessageV2]: {
        title: "The signing order has changed",
        body: "Your order has been changed. The sequence of signers on this request was updated, so please wait for your new turn — we'll email you as soon as you're up.",
      },
      [this.verificationLocked]: {
        title: "Verification limit reached",
        body: "You've entered an incorrect code 5 times. For security, this signing link has been locked. Please contact the requester to resend the request.",
      },
    } as Record<string, { title: string; body: string }>;
  };

  signerNotifyPillLabel = "We'll notify you when it's your turn";
  signerAwaitingTitle = "Awaiting other signers";
  signerAwaitingSubtitle = "We'll email you once the request is complete";
  signerContactRequesterTitle = "Contact the requester";
  signerReasonLabel = "YOUR REASON";
  signerNeedHelpPrefix = "Need help?";
  signerContactSupportLabel = "Contact support";
  signerRequestIdPrefix = "Request ID";

  alreadyApprovedMessage =
    "Your request has already been reviewed and approved";
  nonAssociatedErrorMessage = "You are no longer part";
  notYourTurnErrorMessageV1 = "Your turn to sign has been changed";
  notYourTurnErrorMessageV2 = "Your order has been changed";
  requestDelegatedMessage = "delegated by";

  PRIVACY_POLICY =
    "By clicking below, you confirm acceptance of e-signatures as legally binding, equivalent to traditional ones.";
  CERTIFICATE_TOOLTIP =
    "Self signed: It is simply acknowledgement to the content without any legal binding. \n Certified signed: It is a sign that is verified or authenticated with the legal binding.";

  CLARITY_PROJECT_ID = "qitv7cng2z";
  MIXPANEL_TOKEN = "f21154d95e6cfce1fdac26def13ad010";
  // Public browser key: ships in the JS bundle; access is limited by its GCP referrer/API restrictions (hence the scanner allow markers).
  PLACES_API_KEY = "AIzaSyCrHSvGIrvAphzJJKazMNiGNUnZMB98IWc"; // gitleaks:allow nosemgrep: generic.secrets.security.detected-generic-api-key.detected-generic-api-key

  // Feature gating
  FEATURE_GATE_UPGRADE_TITLE = "Not included in your plan";
  FEATURE_GATE_MAINTENANCE_TITLE = "Feature switched off";
  FEATURE_GATE_UPGRADE_DESCRIPTION_INLINE =
    "This feature isn't included in your current plan.";
  FEATURE_GATE_UPGRADE_DESCRIPTION_FULL =
    "This feature isn't included in your current plan. Upgrade to unlock it — your existing data stays exactly as it is.";
  FEATURE_GATE_FALLBACK_MAINTENANCE_MESSAGE =
    "Your administrator has disabled this feature for the organization. Contact them if you need it enabled.";
  FEATURE_GATE_VIEW_PLANS_BUTTON = "Upgrade";
  FEATURE_GATE_COMPARE_PLANS_BUTTON = "Compare plans";
  FEATURE_GATE_UPGRADE_PLAN_BUTTON = "Upgrade plan";
  FEATURE_GATE_GO_BACK_BUTTON = "Go back";
  FEATURE_GATE_UPSELL_TOOLTIP = "Upgrade your plan to access this feature";
  FEATURE_GATE_TEMPORARILY_UNAVAILABLE_TOOLTIP =
    "This feature is temporarily unavailable";

  // Contacts
  CONTACT_CSV_UPGRADE_TOOLTIP =
    "Bulk uploading contacts via CSV is included in higher plans. Upgrade to enable.";
  CONTACT_DELETE_UNAVAILABLE =
    "Deleting a contact isn't available yet. Please contact support to have it removed.";

  // Dashboard
  DASHBOARD_MONTHLY_RENEWALS_TITLE = "Monthly renewals";
  DASHBOARD_MONTHLY_RENEWALS_INFO =
    "Shows documents that need to be renewed in each month. Click a bar to open the list for that month.";
  DASHBOARD_MONTHLY_RENEWALS_INFO_SHORT =
    "Shows documents that need to be renewed in each month.";
  DASHBOARD_MONTHLY_RENEWALS_SUBTITLE =
    "Documents due to expire in the coming months";
  DASHBOARD_RECENT_ACTIVITY_TITLE = "Recent activity";
  DASHBOARD_RECENT_ACTIVITY_SUBTITLE =
    "The latest sign requests sent from your account";

  // Sending overlay
  SENDING_REQUEST_TITLE = "Sending your request";
  SENDING_REQUEST_DESCRIPTION =
    "We're preparing the documents and emailing every recipient their signing link. This can take a few seconds — please keep this window open.";
  SENDING_REQUEST_FOOTER =
    "Encrypted end-to-end · a tamper-evident audit trail is being generated";
  UPDATING_REQUEST_TITLE = "Updating your request";
  UPDATING_REQUEST_DESCRIPTION =
    "We're saving your changes and re-issuing signing links where they're needed. This can take a few seconds — please keep this window open.";
  APPLYING_SIGNATURE_TITLE = "Applying your signature";
  APPLYING_SIGNATURE_DESCRIPTION =
    "We're sealing the document and preparing your signed copy. This can take a few seconds — please keep this window open.";
  SELF_SIGN_REQUEST_TITLE = "Finishing your document";
  SELF_SIGN_REQUEST_DESCRIPTION =
    "We're applying your signature and sealing the document. This can take a few seconds — please keep this window open.";

  // Post-signing signup attribution.
  // PostHog reads utm_* off the URL on every pageview, so these only have to
  // reach the address bar — nothing in the app reads them back. `utm_content`
  // is what separates the two CTAs a signer can reach /register from.
  UTM_SOURCE_SIGN_COMPLETED = "sign_completed";
  UTM_MEDIUM_INTERNAL = "internal";
  UTM_CAMPAIGN_POST_SIGN_SIGNUP = "post_sign_signup";
  UTM_CONTENT_REGISTER_CTA = "register_cta";
  UTM_CONTENT_SIGNUP_PROMPT = "signup_prompt";

  CONTRACT_SEARCH = "Contract Search";

  /** Intelligent Contract Repository -- copy from `Contract Search Standalone.html`. */
  contractSearch = {
    title: "Contract Search",
    // {count} is the number of indexed contracts.
    // Header subtitle: "Every question searches all **20 contracts**" (count bolded, as on Contacts).
    subtitleLead: "Every question searches all",
    contractSingular: "contract",
    contractPlural: "contracts",
    subtitleNone: "Your completed and uploaded documents will appear here",
    // Count pill beside "New search".
    indexedChip: "{count} contracts indexed",
    indexedChipOne: "1 contract indexed",
    // When the documents list could not be loaded: search still works, we just cannot count.
    subtitleUnknown: "Every question searches all your contracts",
    newSearch: "New search",
    emptyTitle: "Ask anything about your contracts",
    emptyBody:
      "No document picking. Every question runs across all {count} contracts you've uploaded, and every answer quotes its source.",
    emptyBodyUnknown:
      "No document picking. Every question runs across all the contracts you've uploaded, and every answer quotes its source.",
    noDocumentsTitle: "No contracts to search yet",
    noDocumentsBody:
      "Contracts are added here automatically when you upload a document to a sign request or when a request is completed. Processing takes a few seconds. Upload or send a document to get started, then come back and ask your question.",
    composerPlaceholder: "Ask anything about your contracts…",
    composerLabel: "Ask a question about your contracts",
    composerHint: "Enter to send · Shift+Enter for a new line",
    composerNote: "Answers quote the source. Check the passage before relying on it.",
    send: "Send",
    thinking: "Searching {count} contracts…",
    matchedHeading: "MATCHED CONTRACTS",
    matchedCount: "{matched} of {total} contracts",
    partialBadge: "Answered from {used} of {matched} matched contracts",
    partialNote:
      "The other {rest} matched contracts mention this only in passing and weren't used to build the answer. They're marked Not used below.",
    notUsed: "Not used",
    passageOne: "1 passage",
    passages: "{count} passages",
    matchingPassageOne: "1 MATCHING PASSAGE",
    matchingPassages: "{count} MATCHING PASSAGES",
    openInViewer: "Open in viewer",
    refusalTitle: "I can't answer that one",
    emptyAnswer:
      "No contracts matched. I searched all {count} and found nothing that answers this, so there is nothing to quote. Rather than pad the result with weak matches, I'm returning none.",
    errorAnswer: "Couldn't search your contracts. Please try again.",
    followUpsHeading: "SUGGESTED FOLLOW-UPS",
    tryInsteadHeading: "TRY ASKING INSTEAD",
    copyAnswer: "Copy answer",
    retry: "Retry",
    viewerMeta: "Page {page} · lines {lines}",
    viewerPageOnly: "Page {page}",
    openFullPdf: "Open full PDF",
    close: "Close",
    dashboardTitle: "Jump back into Contract Search",
    dashboardBody: "Ask a question across every contract you own. Answers quote the source.",
    starterPrompts: [
      "What's the notice period?",
      "Contracts expiring in 2026",
      "Which contracts allow notice by email?",
      "What are the payment terms?",
    ],
    fallbackFollowUps: [
      "What's the notice period?",
      "Which contracts expire in 2026?",
      "Show all termination clauses",
      "What are the payment terms?",
    ],
    refusalFollowUps: [
      "Which contracts name a governing law?",
      "What is the cure period in each contract?",
      "Show every termination clause",
      "What are the payment terms?",
    ],
    signedOn: "Signed {date}",
    uploadedOn: "Uploaded {date}",
    pageCountOne: "1 page",
    pageCount: "{count} pages",
    untitledDocument: "Untitled document",
    maxQueryLength: 1000,
  };

  /**
   * Pre-send review popup -- copy from the Figma "Pre-send review popup" states. It opens on the
   * editor's Next, so its primary action continues to the next step rather than sending ("Continue",
   * not the mock's "Send"). The review's own title, message and findings come from the AI as plain
   * text; only the chrome lives here.
   */
  presendReview = {
    eyebrow: "PRE-SEND REVIEW",
    loadingTitle: "Checking your document…",
    loadingTitlePlural: "Checking your documents…",
    loadingMessage:
      "We're looking at required fields, signature fields, placeholders and sensitive information. This usually takes a few seconds.",
    loadingNote: "You don't have to wait. The review never stops you from continuing.",
    checking: "Checking…",
    backToEditor: "Back to editor",
    continue: "Continue",
    continueAnyway: "Continue anyway",
    dismiss: "Dismiss",
    whatToDo: "WHAT TO DO",
    showOnPage: "Show on page {page}",
    status: {
      ready: "Ready",
      needs_attention: "Needs attention",
      not_reviewed: "Not reviewed",
    },
    severity: { high: "High", medium: "Medium", low: "Low" },
    countHigh: "{count} High",
    countMedium: "{count} Medium",
    countLow: "{count} Low",
    countNotChecked: "{count} Couldn't check",
    issueOne: "1 issue",
    issues: "{count} issues",
    checkedNoIssues: "Checked · no issues",
    noIssues: "No issues",
    couldNotCheck: "{count} couldn't check",
    categories: {
      signature: "SIGNATURES",
      pii: "SENSITIVE INFORMATION",
      required_field: "REQUIRED FIELDS",
      party: "PARTIES",
      placeholder: "BLANKS AND PLACEHOLDERS",
      other: "OTHER",
    },
    couldNotCheckHeading: "COULDN'T CHECK",
    dismissedCount: "{count} dismissed",
    showDismissed: "Show",
    unavailableTitle: "Review unavailable right now",
    unavailableMessage: "You can still continue.",
    tryAgain: "Try again",
    rateLimitedTitle: "You're going a bit fast",
    rateLimitedMessage: "Try again in {seconds} s.",
    tryAgainIn: "Try again in {seconds} s",
    sessionTitle: "Your session has expired",
    sessionMessage: "Sign in again to run the review.",
    cancel: "Cancel",
    signIn: "Sign in",
  };

  // Dashboard seasonal promotions (strip + popup). Dates and percentages are
  // filled from the schedule in `helpers/promotionHelpers` via `fillCopy`, and
  // `**…**` marks the emphasised runs of a strip line.
  promotions = {
    storagePrefix: "inkfree.promo",
    phaseOverrideParam: "promoPhase",
    stripAria: "{badge} promotion",
    dismissStrip: "Dismiss promotion",
    viewOffer: "View my offer",
    notifyMe: "Notify me",
    strip: {
      teaser: {
        badge: "BLACK FRIDAY · COMING SOON",
        text: "Our biggest sale of the year starts **{bfStart}**. Get notified when savings go live.",
      },
      bf: {
        badge: "BLACK FRIDAY",
        text: "Save **{bfAnnual}% on your first year annually** or **{bfMonthly}% on your first 3 months monthly**. Ends **{bfEnd}**.",
      },
      bfFinal: {
        badge: "BLACK FRIDAY · FINAL DAYS",
        text: "Last chance: Save **up to {bfAnnual}%** before Black Friday ends **{bfEnd}**.",
      },
      ye: {
        badge: "YEAR-END SALE",
        text: "Save **{yeAnnual}% on your first year annually** or **{yeMonthly}% on your first 3 months monthly**. Ends **{yeEnd}**.",
      },
      yeFinal: {
        badge: "YEAR-END SALE · FINAL DAYS",
        text: "Final days: Save **up to {yeAnnual}%** before the Year-End Sale ends **{yeEnd}**.",
      },
    },
    popup: {
      saveUpTo: "SAVE UP TO",
      heroAnnual: "off your first year · annual billing",
      heroMonthly: "off your first 3 months · monthly",
      percentOff: "{pct}% off",
      annualWhat: "Your first year",
      annualHow: "Billed annually",
      monthlyWhat: "Your first 3 months",
      monthlyHow: "Billed monthly",
      autoApplied: "Your discount applies automatically at checkout.",
      claim: "Claim my discount",
      notNow: "Not now",
      close: "Close",
      bf: {
        badge: "BLACK FRIDAY · ENDS {endShort}",
        finalBadge: "LAST CHANCE · ENDS {endShort}",
        title: "Less paperwork. Bigger Black Friday savings.",
        sub: "Choose an eligible Inkfree plan and save up to {annual}%.",
      },
      ye: {
        badge: "YEAR-END SALE · ENDS {endShort}",
        finalBadge: "FINAL DAYS · ENDS {endShort}",
        title: "Start the year with less paperwork.",
        sub: "Get your signing workflows ready for the year ahead with up to {annual}% off.",
      },
    },
    // Settings → My Plan: summary banner, "Choose your plan" strip and cards,
    // checkout note.
    plan: {
      aria: "{name} offer",
      bf: { name: "Black Friday", shortBadge: "BLACK FRIDAY", bannerHead: "Your Black Friday savings" },
      ye: { name: "Year-End", shortBadge: "YEAR-END SALE", bannerHead: "Your Year-End savings" },
      bannerSub: "Applies automatically at checkout. Your current subscription stays unchanged until you confirm.",
      offerOff: "{pct}% OFF",
      offerAnnual: "First year · annual",
      offerMonthly: "First 3 months · monthly",
      saveUpTo: "Save up to",
      choiceLine: "{annual}% off your first year annually or {monthly}% off your first 3 months monthly.",
      autoApplied: "Your discount applies automatically at checkout. Your current subscription stays unchanged until you confirm.",
      cycleAnnual: "{pct}% off · First year",
      cycleMonthly: "{pct}% off · First 3 months",
      billedAnnual: "billed annually · first year",
      billedMonthly: "for your first 3 months",
      totalAnnual: "{qty}{unit} × 12 = {total} first year",
      totalMonthly: "{qty}{unit} = {total}/mo",
      renewAnnual: "Then {total}/year at the regular price",
      renewMonthly: "Then {total}/month at the regular price",
      claim: "Claim my discount →",
      regularPriceLabel: "Regular price ",
      pricePreviewParam: "promoPrices",
      offerPriceLabel: "Offer price ",
      appliedAnnual: "{pct}% off your first year is applied",
      appliedMonthly: "{pct}% off your first 3 months is applied",
    },
  };

  /** "Build with AI" for web forms: the build-choice dialog and the build screen. */
  aiWebForm = {
    // Build-choice dialog
    choiceTitle: "How do you want to build this form?",
    choiceSubtitle: "{template} · Signer: {signer}",
    buildWithAi: "Build with AI",
    newBadge: "New",
    buildWithAiBody:
      "AI builds the form from your template in the Inkfree look. Then refine it by chatting: “make the button green”, “two columns”.",
    describeLabel: "Describe the look you want",
    optional: "(optional)",
    describePlaceholder: "e.g. Modern and friendly, two columns, our brand green",
    describeChips: [
      "Modern, two columns",
      "Friendly tone",
      "Dark theme",
      "Questions in Spanish",
    ],
    withoutAi: "Continue without AI",
    withoutAiBody: "Build the form yourself in the drag-and-drop editor.",
    continueEyebrow: "Continue your AI design",
    continueMeta: "Version {version} · {messages} · Edited {when}",
    oneMessage: "1 message",
    manyMessages: "{count} messages",
    publishedVersionBadge: "Published v{version}",
    continueButton: "Continue",
    removeFromList: "Remove from my list",
    or: "or",
    startNew: "Start a new AI design",
    startNewBody:
      "Starts over from your template. Your current AI design stays in your list.",
    back: "Back",
    // Header
    aiBadge: "AI design",
    templateLine: "Template: {template} · Signer: {signer}",
    templateOnlyLine: "Template: {template}",
    notPublished: "Not published yet",
    publishedStatus: "Published v{version}",
    versionButton: "Version {version}",
    building: "Building…",
    current: "Current",
    publish: "Publish",
    backToWebForms: "Back to web forms",
    // Chat
    designerTitle: "AI designer",
    designerSubtitle: "Describe a change and watch the preview update",
    moreActions: "More actions",
    boundaries:
      "I can change colours, fonts, layout and wording. Fields, required flags and choices come from your template.",
    showEarlier: "Show earlier messages",
    today: "Today",
    you: "You",
    colleague: "A colleague",
    whatChanged: "What changed",
    afterMessage: "After message #{turn}",
    createdFromPdf: "Created from your PDF",
    restoredFrom: "Restored from v{version}",
    noChange: "No change · still v{version}",
    openingLine: "Create a webform for this document.",
    styleLine: "Style: {style}",
    onePage: "1 page",
    manyPages: "{count} pages",
    fieldsFor: "{count} fields for {signer}",
    fieldsOnly: "{count} fields",
    stepRead: "Reading your document…",
    stepBuild: "Building your form…",
    stepStyle: "Applying your style: “{style}”",
    stepLook: "Applying the Inkfree look",
    startingNote:
      "This can take up to a minute. You can leave this page; your design will be saved.",
    working: "Working on your change…",
    workingNote:
      "Usually 5–15 seconds. The preview stays as it is until I'm done.",
    tryAgain: "Try again",
    darkerButtonText: "Make the button text darker",
    easierToRead: "Make the colours easier to read",
    tryHeading: "Try",
    tryChips: [
      "Make the button green",
      "Rounded input boxes",
      "Two columns",
      "Use Poppins font",
      "Dark theme",
      "Add a welcome page",
      "Back to Inkfree colours",
    ],
    composerPlaceholder: "Describe a change, e.g. “make the questions friendlier”",
    composerLabel: "Describe a change",
    send: "Send",
    counter: "{count}/{max}",
    restoredByMe: "You restored version {version}",
    restoredByColleague: "A colleague restored version {version}",
    restoredBySomeone: "Version {version} was restored",
    chatLog: "Conversation with the AI designer",
    // What changed
    layoutUpdated: "Layout updated",
    oneQuestionReworded: "1 question reworded",
    questionsReworded: "{count} questions reworded",
    sectionTitle: "Section {number} title",
    themeNames: {
      page: "Page background",
      surface: "Card background",
      ink: "Text colour",
      muted: "Help text colour",
      accent: "Accent colour",
      accentInk: "Text on the accent",
      accentHover: "Button hover colour",
      tint: "Section heading band",
      rule: "Card border",
      headingFont: "Heading font",
      bodyFont: "Body font",
      radius: "Card corners",
      scale: "Text size",
      spacing: "Spacing",
      button: "Button style",
      buttonColor: "Button colour",
      buttonInk: "Button text colour",
      buttonRadius: "Button corners",
      welcomeStep: "Welcome page",
      columns: "Columns",
      "controls.border-color": "Input border colour",
      "controls.border-width": "Input borders",
      "controls.border-radius": "Input corners",
      "controls.background-color": "Input background",
      "controls.color": "Input text colour",
      "controls.font-size": "Input text size",
    } as Record<string, string>,
    formNames: {
      title: "Title",
      welcomeHeading: "Welcome heading",
      welcomeBody: "Welcome text",
      submit: "Submit button",
      thankHeading: "Thank-you heading",
      thankBody: "Thank-you text",
    } as Record<string, string>,
    // Preview
    tabsLabel: "Show",
    chatTab: "Chat",
    previewTab: "Preview",
    previewUpdated: "Preview updated",
    preview: "Preview",
    previewMeta: "Version {version} · {origin}",
    previewSize: "Preview size",
    desktop: "Desktop",
    phone: "Phone",
    showThankYou: "Show thank-you page",
    thankYouPage: "Thank-you page",
    previewTitle: "Webform preview",
    previewingBanner: "You're previewing version {version} · {origin}",
    backToCurrent: "Back to current",
    restoreVersion: "Restore v{version}",
    // Versions
    versionsTitle: "Versions",
    versionsSubtitle: "Click a version to preview it",
    byColleague: "by a colleague",
    publishedBadge: "Published",
    restore: "Restore",
    publishThisVersion: "Publish this version",
    restoreNote:
      "Restoring makes a new version that copies the old one. Nothing is deleted, and you can always come back.",
    closeVersions: "Close versions",
    restored: "Restored version {version} as version {next}.",
    // Publish
    publishTitle: "Publish version {version}?",
    publishSubtitle:
      "Signers will see exactly this design. You can publish another version later.",
    replaceNoticeStrong: "This replaces the current webform for this signer.",
    replaceNoticeRest: " The current one will be archived.",
    newTextHeading: "New text on your page",
    newTextBody:
      "The AI added these words to the page. Check them before signers see them.",
    checkFieldsHeading: "Check these fields",
    backToEditing: "Back to editing",
    publishVersion: "Publish v{version}",
    published: "Published version {version}. Signers now see this design.",
    // Changed meanwhile (409)
    staleBanner:
      "This design was changed (maybe by a colleague). We loaded the latest version. Your message is still in the box, so you can send it again.",
    staleToast: "Loaded the latest version (v{version})",
    /**
     * How the AI's stale-version 409 begins, its only mark today (both its status and body code are 409).
     * Not shown to anyone: pinned by AiWebFormHelper.test.ts; a machine-readable code is asked of ss-ai-service.
     */
    staleConflictPrefix: "The design has changed since version",
    dismiss: "Dismiss",
    // Template changed since the design
    fieldsChanged:
      "Your template's fields changed after this design was made, so it can't be published as it is.",
    buildNew: "Build a new AI design",
    // Whole-page states
    switchedOff:
      "Build with AI isn't available right now. You can still build the form in the drag-and-drop editor.",
    startFailed: "We couldn't start your AI design.",
    notFound: "This AI design is no longer available.",
    chatNotFound: "This form was built with AI, but its AI design could not be found.",
    loadFailed: "We couldn't load this AI design.",
    loading: "Loading your AI design",
    retry: "Try again",
    removed: "Removed from your list.",
    // Selection prompt
    promptLabel: "Tell AI what to change",
    promptPlaceholder: "e.g. make it shorter, change to Spanish",
    promptAriaLabel: "Instruction for AI",
    promptDisabledTooltip: "Switch to current version to make changes",
    promptSwitchToCurrent: "Back to current",
  };
}

let strings = new StringConstants();
export default strings;
